export default __webpack_public_path__ + "static/media/16_1.323ecd82.jpg";